import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import HomeScreen from 'components/NextconLabHome/HomeScreen';
import Mission from 'components/NextconLabHome/Mission';
import Vision from 'components/NextconLabHome/Vision';
import Goal from 'components/NextconLabHome/Goal';
import NewSlider from 'components/NextconLabHome/newSlider';
import NewSlider_2 from 'components/NextconLabHome/newSlider_2';


function Home() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? ( 
      <>
        <MobileNavbar />
        <HomeScreen />
        <hr />
        <Mission />
        <hr />
        <Vision />
        <hr />
        <NewSlider />
        <hr />
        <Goal />
        <hr />
        <NewSlider_2 />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <HomeScreen />
        <hr />
        <Mission />
        <hr />
        <Vision />
        <hr />
        <NewSlider />
        <hr />
        <Goal />
        <hr />
        <NewSlider_2 />
        <Footer />
      </>
    )}
    </>
  );
}

export default Home;
